/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_DescriptionInputs */

const en_cookie_description = /** @type {(inputs: Cookie_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use optional cookies for analytics and advertising.`)
};

const lv_cookie_description = /** @type {(inputs: Cookie_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izmantojam neobligātās sīkdatnes analītikai un reklāmai.`)
};

/**
* | output |
* | --- |
* | "We use optional cookies for analytics and advertising." |
*
* @param {Cookie_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_description = /** @type {((inputs?: Cookie_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_description(inputs)
	return en_cookie_description(inputs)
});